import ace from 'ace-builds/src-noconflict/ace'
import jsWorkerUrl from 'ace-builds/src-noconflict/worker-javascript?url'
import jsonWorkerUrl from 'ace-builds/src-noconflict/worker-json?url'
import cssWorkerUrl from 'ace-builds/src-noconflict/worker-css?url'
import htmlWorkerUrl from 'ace-builds/src-noconflict/worker-html?url'

// This code should be run ASAP post start
// There is a weird race-condition which does SOMETIMES result in worker url not resolving properly
// IN BUILT APP ONLY - it however seems to reliably happen in some Cypress test scenarios.
// This workaround seems to resolve this problem.
ace.config.setModuleUrl('ace/mode/javascript_worker', jsWorkerUrl)
ace.config.setModuleUrl('ace/mode/json_worker', jsonWorkerUrl)
ace.config.setModuleUrl('ace/mode/css_worker', cssWorkerUrl)
ace.config.setModuleUrl('ace/mode/html_worker', htmlWorkerUrl)
